import ApplyTemplate from './ApplyTemplate'

export default ApplyTemplate
